'use strict';

angular.module('app.services')
.service('NotificacaoStream', NotificacaoStream);

NotificacaoStream.$inject = ['$rootScope', 'ConfigApp', 'Event', '$q'];

function NotificacaoStream ($rootScope, ConfigApp, Event, $q)
{
    var connection = $.hubConnection(ConfigApp.UrlBase);
    var hubProxy = connection.createHubProxy('notificacaoHub');
    var deferred = $q.defer();

    var registrados = [];

    /**
     * Adiciona ouvintes para serem disparados quando o 
     * evento for acionado
     * 
     * @param string evento
     * @param function handle
     */
    this.em = function(evento, manipulador)
    {
        hubProxy.on(evento, function () {
            var args = arguments;

            $rootScope.$apply(function () {
                manipulador.apply(this, args);
            });
        });

        return this;
    }

    /**
     * Adiciona ouvintes para serem disparados quando o 
     * evento for acionado.
     * 
     * @param args argumentos [event, handle]
     */
    this.ouvir = function(/* argunments */)
    {
        return this.em.apply(this, arguments);
    }

    /**
     * Abre um sockete de comunicação
     * com um canal especifico.
     * 
     * @param name
     */
    this.canal = function (nome)
    {
        if( !registrados[nome] ) {
            hubProxy.invoke('JoinGroup', nome).done( function(e){
                registrados.push(nome)
            });
        }

        return this;
    }

    /**
     * Abre um socket de comunicação
     * com um usuário especifico.
     * 
     * @param name
     */
    this.usuario = function( nome )
    {
        return this.canal(nome);
    }

    /**
     * Abre um sockete de comunicação com uma lista de
     * canais.
     * 
     * @param {array} canais 
     */
    this.canais = function ( canais )
    {
        var $this = this;

        canais.forEach(function (nome) {
            $this.canal (nome)
        })

        return $this;
    }

    /**
     * Conecta a aplicação 
     */
    this.conectar = function ()
    {
        connection 
        
        .start(function () {
            //deferred.resolve(arguments)
        })
        .done(function () {
            deferred.resolve(arguments)
        })
        .fail( function () {
            deferred.reject(arguments)
        });
        
        return deferred.promise;
    }
}



//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/services/notificacao-stream-service.js
// module id = 329
// module chunks = 1